import React from 'react'
import PropTypes from 'prop-types'

import { TextField, InputAdornment, IconButton } from '@material-ui/core'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSave } from '@fortawesome/pro-solid-svg-icons'

class UsernameDomainEditor extends React.Component {
  static propTypes = {
    domain: PropTypes.string,
    canEdit: PropTypes.bool.isRequired,
    onSave: PropTypes.func.isRequired,
    onModification: PropTypes.func.isRequired,
  }
  static defaultProps = {
    domain: '',
  }
  state = {
    domain: this.props.domain,
  }
  render() {
    const disabled = !this.props.canEdit
    return (
      <form
        onSubmit={(e) => {
          e.preventDefault()
          this.props.onSave(this.state.domain)
        }}
        autoComplete="on"
      >
        <TextField
          value={this.state.domain}
          label="Username"
          onChange={(e) => {
            this.setState({ domain: e.target.value })
            this.props.onModification()
          }}
          variant="outlined"
          disabled={disabled}
          margin="normal"
          fullWidth
          id="username-domain-editor"
          name="Username"
          autoComplete="username"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  disabled={disabled || this.state.domain.length === 0}
                  aria-label={'save username'}
                  edge="end"
                  type="submit"
                >
                  <FontAwesomeIcon icon={faSave} />
                </IconButton>
              </InputAdornment>
            ),
            startAdornment: <InputAdornment position="start">scoir@</InputAdornment>,
          }}
          FormHelperTextProps={{ role: 'alert' }}
          helperText={this.state.domain !== this.props.domain ? '' : 'Username saved'}
        />
      </form>
    )
  }
}

export default UsernameDomainEditor
